module.exports = __webpack_public_path__ + "img/gsb27.448dc386.png";